// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import keycode from 'keycode'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import { getUtcTimestampSeconds } from 'utilities/time'
import { getStorage, setStorage } from 'utilities/storage'

// Redux:
import { showLoginNudgeModal } from 'actions/site'

class LoginNudgeModal extends React.Component {
	componentDidMount() {
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleClose()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleClose()
		}
	}

	handleClose = () => {
		const { dispatch, showLoginNudgeModalType } = this.props

		if ( 'previously_logged_in_user_reminder' == showLoginNudgeModalType ) {
			// If the log back in reminder is dismissed, treat as though the user logged out manually,
			// resetting the wait time before showing again.
			setStorage( 'auth_has_logged_out_manually', '1' )
			setStorage( 'auth_has_logged_out_manually_timestamp', getUtcTimestampSeconds() )
		}

		if ( 'existing_user' == showLoginNudgeModalType || 'existing_user_reminder' == showLoginNudgeModalType || ! showLoginNudgeModalType ) {
			// If the log in reminder is dismissed, reset the wait time before showing again.
			setStorage( 'login_nudge_reminder_last_seen_timestamp', getUtcTimestampSeconds() )
		}

		this.handleAction()

		this.setState( {
			isOpen: false
		} )

		setTimeout( () => {
			dispatch( showLoginNudgeModal( false ) )
		}, 300 )
	}

	handleAction = () => {
		const { dispatch } = this.props

		setStorage( 'has_seen_login_nudge', '1' )
	}

	render() {
		const { showLoginNudgeModal, showLoginNudgeModalType, auth_has_logged_in_before } = this.props

		if ( ! showLoginNudgeModal ) {
			return null
		}

		return (
			<div className="modal login-nudge-modal" ref={ ( e ) => { this.outside = e } } tabIndex="0">
				<div className="-inner">
					{ 'existing_user' == showLoginNudgeModalType &&
						<div>
							<h4>News Flash!</h4>

							<div className="-text">
								<p>Did you know you can now create an account to earn badges and unlock more content... even before it goes to air!</p>
							</div>
						</div>
					|| 'existing_user_reminder' == showLoginNudgeModalType &&
						<div>
							<h4>You're missing out!</h4>

							<div className="-text">
								<p>Did you know you can now create an account to earn badges and unlock more content... even before it goes to air!</p>
							</div>
						</div>
					|| 'previously_logged_in_user_reminder' == showLoginNudgeModalType &&
						<div>
							<h4>Log in</h4>

							<div className="-text">
								<p>Log back in to earn badges and unlock more content... even before it goes to air!</p>
							</div>
						</div>
					||
						<div>
							<h4>Congratulations!</h4>

							<div className="-text">
								<p>You've chosen your Faith FM station and can enjoy our <strong>positively different</strong> radio wherever you are.</p>
								<p>Create an account to earn badges and unlock more content... even before it goes to air!</p>
							</div>
						</div>
					}

					<div className="-actions">
						<div className="button" onClick={ this.handleClose }>Continue without logging in</div>

						{ ! auth_has_logged_in_before &&
							<Link to="/signup" className="button is-active">Sign up</Link>
						}

						{ ! auth_has_logged_in_before &&
							<Link to="/signin" className="button">Log in</Link>
						||
							<Link to="/signin" className="button is-active">Log in</Link>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		showLoginNudgeModal: state.site.showLoginNudgeModal,
		showLoginNudgeModalType: state.site.showLoginNudgeModalType,
		auth_has_logged_in_before: state.schedule.auth_has_logged_in_before
	}
}

export default connect( mapStateToProps )( LoginNudgeModal )
